var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0961 8.60668L10.8461 2.7098C10.843 2.70714 10.8402 2.70427 10.8375 2.70121C10.6074 2.49194 10.3075 2.37598 9.99648 2.37598C9.68545 2.37598 9.38558 2.49194 9.15547 2.70121L9.14688 2.7098L2.90391 8.60668C2.77656 8.72378 2.67491 8.86604 2.60538 9.02445C2.53586 9.18287 2.49997 9.35399 2.5 9.52699V16.7496C2.5 17.0812 2.6317 17.3991 2.86612 17.6335C3.10054 17.868 3.41848 17.9996 3.75 17.9996H7.5C7.83152 17.9996 8.14946 17.868 8.38388 17.6335C8.6183 17.3991 8.75 17.0812 8.75 16.7496V12.9996H11.25V16.7496C11.25 17.0812 11.3817 17.3991 11.6161 17.6335C11.8505 17.868 12.1685 17.9996 12.5 17.9996H16.25C16.5815 17.9996 16.8995 17.868 17.1339 17.6335C17.3683 17.3991 17.5 17.0812 17.5 16.7496V9.52699C17.5 9.35399 17.4641 9.18287 17.3946 9.02445C17.3251 8.86604 17.2234 8.72378 17.0961 8.60668ZM16.25 16.7496H12.5V12.9996C12.5 12.6681 12.3683 12.3502 12.1339 12.1158C11.8995 11.8813 11.5815 11.7496 11.25 11.7496H8.75C8.41848 11.7496 8.10054 11.8813 7.86612 12.1158C7.6317 12.3502 7.5 12.6681 7.5 12.9996V16.7496H3.75V9.52699L3.75859 9.51918L10 3.62465L16.2422 9.51762L16.2508 9.52543L16.25 16.7496Z",
    fill: "#7A757F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarHome);
export default __webpack_public_path__ + "static/media/dar_home.59ee02f06c2e12d9b7efaffb0e06fdb9.svg";
export { ForwardRef as ReactComponent };